import { render, staticRenderFns } from "./PDetailWhenNotLoggedIn.vue?vue&type=template&id=2b616877&scoped=true&"
import script from "./PDetailWhenNotLoggedIn.vue?vue&type=script&lang=ts&"
export * from "./PDetailWhenNotLoggedIn.vue?vue&type=script&lang=ts&"
import style0 from "./PDetailWhenNotLoggedIn.vue?vue&type=style&index=0&id=2b616877&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b616877",
  null
  
)

export default component.exports